export const adminConfig = {
  sidebarNav: [
    {
      title: "Overview",
      href: "/admin/overview",
      icon: "layout-dashboard",
    },
    {
      title: "Mahallu",
      href: "/admin/community",
      icon: "users",
    },
    {
      title: "Sponsorships",
      href: "/admin/donors",
      icon: "heart",
    },
    {
      title: "Payments",
      href: "/admin/finance",
      icon: "wallet",
    },
    {
      title: "HAF Payments",
      href: "/admin/haaf-payments",
      icon: "credit-card",
    },
    {
      title: "Follow-Ups",
      href: "/admin/follow-ups",
      icon: "phone",
    },
    {
      title: "Manage",
      href: "/admin/manage",
      icon: "settings",
    },
  ],
};
